import React from 'react';

type IconProp = React.FC<{ height: number; className?: string }>;

interface BenefitProps {
  Icon: IconProp;
  iconClassName?: string;
  heading: string;
  description: string;
}

const Benefit = ({ Icon, iconClassName, heading, description }: BenefitProps) => {
  return (
    <div className="inline-flex flex-col items-start justify-start">
      <Icon height={75} className={iconClassName} />
      <h3 className="mb-0 mt-24 font-suisse-screen text-headline-alt-sm text-primary-black">
        {heading}
      </h3>
      <div className="mt-16 font-suisse-neue text-body-lg text-primary-black">{description}</div>
    </div>
  );
};

export default Benefit;
